<div class="np-form-control dx-fieldset">
  <dx-validation-group id="SW6">
    <dx-box class="gap-4 mb-4" direction="row" crossAlign="stretch" width="100%">
      <dxi-item [ratio]="1">
        <div class="dx-card mb-4">
          <div class="dx-fieldset d-flex flex-column gap-4">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="false"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Aus Verkaufskanäle ausschließen' | translate }}"
                             field="EXCLUDE_FROM_SALESCHANNELS_SHOPWARE6"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot np-others">
                <dx-tag-box [items]="salesChannels"
                            displayExpr="name"
                            valueExpr="name"
                            (onValueChanged)="update($event, 'EXCLUDE_FROM_SALESCHANNELS_SHOPWARE6')"
                            [(value)]="model.shopware6Configuration.excludeFromSalesChannels"
                            [readOnly]="readOnly('EXCLUDE_FROM_SALESCHANNELS_SHOPWARE6')">
                </dx-tag-box>
              </div>
            </np-inputControl>
          </div>
          <div class="dx-fieldset d-flex flex-column gap-4">
            <np-inputControl [(model)]="model"
                             [showLinkButtons]="false"
                             [suppressPlaceLabel]="true"
                             [(selectedElements)]="selectedElements"
                             (elementSelected)="elementSelectFunction($event)"
                             (onValueChanged)="update($event)"
                             labelText="{{ 'Aus dem Export ausschließen' | translate }}"
                             field="EXCLUDE_FROM_SHOPWARE6"
                             [showDragHandle]="showDragHandle"
                             [dragFilter]="dragFilter"
                             (excelElementDropped)="excelElementDrop($event)">
              <div slot="content" class="contentSlot np-others">
                <np-booleanRadioGroup [(value)]="model.shopware6Configuration.excludeFromExport"
                                      [templateView]="templateView"
                                      [readOnly]="readOnly('EXCLUDE_FROM_SHOPWARE6')"
                                      [fieldName]="validationService.fieldNames.excludeFromShopware6"
                                      [showNullValue]="false"
                                      (onValueChanged)="update($event, 'EXCLUDE_FROM_SHOPWARE6')"
                                      validatorValidationGroup="SW6" />
              </div>
            </np-inputControl>
          </div>
        </div>
      </dxi-item>
    </dx-box>
  </dx-validation-group>
</div>
